import request from "../utils/request";

export function GET_UseLogList(token, payload) {
  return request.post("/uselog/list", payload, {
    headers: {
      Authorization: token,
    },
  });
}
